export default __webpack_public_path__ + "static/media/cdlog_v2.e6b68395.jpg";